import { render, staticRenderFns } from "./BulkEmailList.vue?vue&type=template&id=71770f7c&"
import script from "./BulkEmailList.vue?vue&type=script&lang=js&"
export * from "./BulkEmailList.vue?vue&type=script&lang=js&"
import style0 from "./BulkEmailList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports